import React, { useEffect, useLayoutEffect } from "react";
import { Box } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";

import { ensureNamespaceLoaded } from "../../i18n/lazyNamespaces";
import { bootstrapWorkspaceFromUrl } from "../../utils/bootstrapWorkspaceFromUrl";
import {
  getActiveWorkspaceSlug,
  normalizeWorkspaceSlug,
} from "../../utils/workspaceStorage";
import CallNotification from "../../components/CallNotification";
import Chat from "../Chat";

const CallPopup = () => {
  const location = useLocation();
  const { id } = useParams();

  // Aplica tenant antes de montar Chat (header Company e react-query).
  bootstrapWorkspaceFromUrl(location.search);

  useLayoutEffect(() => {
    bootstrapWorkspaceFromUrl(location.search);
  }, [location.search]);

  useEffect(() => {
    void ensureNamespaceLoaded("chat");
  }, []);

  const workspaceKey = (() => {
    const params = new URLSearchParams(location.search || "");
    return (
      normalizeWorkspaceSlug(params.get("ws") || params.get("company")) ||
      getActiveWorkspaceSlug() ||
      "default"
    );
  })();

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <Chat key={`${workspaceKey}:${id || ""}`} />
      <CallNotification />
    </Box>
  );
};

export default CallPopup;
